import React from "react";
import {capitalizeFirstLetter} from "../../../helpers/stringHelper";
import {Tag} from "../../../components/table/Status";

function ProductItem({product}) {
  return (
    <div className="w-full sm:w-72 border bg-white space-x-2 rounded-tl-[2.3rem] rounded-bl-md  rounded-tr-md rounded-br-md flex mr-2 mb-2">
      <div className="rounded-full border h-16 w-16 bg-white shrink-0 overflow-hidden">
        <img
          src={product.image[0][128]}
          alt="images" className="h-full w-full object-contain"/>
      </div>
      <div className="p-2">
        <div className="text-2-clamp h-12 mb-2">{capitalizeFirstLetter(product.label)}</div>
        <div className="text-sm font-medium">NPR. {product.price.toFixed(2)}</div>
      </div>

    </div>
  )
}

export default ProductItem